
import api from '../base';

import type { Paths, Response, Schemas } from '../types';

export type ContactMessageRequest = Schemas['ContactMessageRequest']

class ContactsApi {

    static sendMessage(data: ContactMessageRequest): Response<any> {
        const url: keyof Paths = '/dj/contacts/message/';
        return api.post({ url, data });
    }
}

export default ContactsApi;
